import * as React from "react";
import { Layout, setSidebarVisibility, useSetLocale } from "react-admin";
import menu from "./menu";
import MyAppBar from "./MyAppBar";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadLocale } from "../utils/settings";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  root: {
    "& :nth-child()": {
      marginTop: 70
    },
  },
});
const MyLayout = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { handle } = props;
  const setLocale = useSetLocale();
  useEffect(() => {
    dispatch(setSidebarVisibility(false));
    const [locale, error] = loadLocale();
    if (error) {
      return;
    }

    setLocale(locale);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Layout
      className={{root: classes.root}}
      {...props}
      menu={menu}
      appBar={(props) => MyAppBar({ ...props, handle })}
    />
  );
};

export default MyLayout;
